// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottomMenu{
    display: flex;
    justify-content: center;
    gap: 26px;
    background: #F3F6FF;
    border-radius: 8px;
    padding: 2px;
}

.bottomMenu_button{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    height: 28px;
    
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #212633;
    border: 1px solid transparent;
}

.bottomMenu_button--active{
    background: #FFFFFF;
    border: 1px solid #E2E9FC;
    box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);
    border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/bottomMenu/BottomMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;;IAEZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,wFAAwF;IACxF,kBAAkB;AACtB","sourcesContent":[".bottomMenu{\n    display: flex;\n    justify-content: center;\n    gap: 26px;\n    background: #F3F6FF;\n    border-radius: 8px;\n    padding: 2px;\n}\n\n.bottomMenu_button{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 24px;\n    height: 28px;\n    \n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    color: #212633;\n    border: 1px solid transparent;\n}\n\n.bottomMenu_button--active{\n    background: #FFFFFF;\n    border: 1px solid #E2E9FC;\n    box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);\n    border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
